import { useEffect, useState,useRef } from 'react';
import { Config } from 'src/config';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { CommonHelper } from 'src/utils/commonHelper';
import CustomDomainRedirectIframe from '../customDomainIframe';
import ThreadsAuthorizationModal from './threads-authorization-modal';
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';

const ThreadsIntegration = (props) => {
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  const { showResellerLimitDialog } = useResellerLimitDialog();
  const isCustomDomain = CommonHelper.CustomDomain();
  let intervalId = null;
  let isProcessing = false;
  const messageListenerRef = useRef(null);

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAccessTokenReceivedFromThreads();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
      cleanupListener();
    };
  }, []);

    const getThreadsOauthToken = () => {
    let redirectUri = encodeURIComponent(Config.Threads.redirectUri);
    window.open(
      `${Config.Threads.authorizeUrl}?client_id=${Config.Threads.clientId}&redirect_uri=${redirectUri}&scope=${Config.Threads.scope}&response_type=code`,
      '_blank'
    );
  };

  const cleanupListener = () => {
    if (messageListenerRef.current) {
      window.removeEventListener('message', messageListenerRef.current, false);
      messageListenerRef.current = null; // Reset the ref
    }
  };

  const checkAccessTokenReceivedFromThreads = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === 'threads_auth_code' && code && !isProcessing) {
          isProcessing = true;
          cleanupListener(); // Remove event listener
          clearInterval(intervalId); // Stop polling
          sendAccessTokenToServer(code); // Process the code
        }
      };

      if (!messageListenerRef.current) {
        window.addEventListener('message', handleMessage, false);
        messageListenerRef.current = handleMessage; // Save the reference
      }
    } else {
      var token = localStorage.getItem('threads_auth_code');
      var error = localStorage.getItem('threads_error');
      if (token) {
        localStorage.removeItem('threads_auth_code');
        clearInterval(intervalId);
        sendAccessTokenToServer(token);
      } else if (error) {
        localStorage.removeItem('threads_error');
        clearInterval(intervalId);
        showToast(error, 'e');
        handleClose();
      }
    }
  };
  const threadsSuccessCallback = (data, message) => {
    CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_SOCIAL_ACCOUNT_CONNECTED,"THREADS")
    showToast(message, 's');
    handleClose();
  };
  const threadsFailureCallback = (message) => {
    if (!showResellerLimitDialog(message)) {
      message && showToast(message, 'e');
    }
    handleClose();
  };
  const sendAccessTokenToServer = (code) => {
    let threadsForm = {
      code,
    };
    let postProps = {
      url: integrateModuleURL.sendThreadsAccessToken,
      body: threadsForm,
      successCallback: threadsSuccessCallback,
      failureCallback: threadsFailureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleClose = () => {
    props.handleClose();
    cleanupListener();
  };

  return (
    <>
      {isAuthorizationModalOpen && (
        <ThreadsAuthorizationModal handleConnectThreads={getThreadsOauthToken} handleClose={handleClose} />
      )}
      {isCustomDomain && <CustomDomainRedirectIframe serviceName="threads" />}
    </>
  );
};
export default ThreadsIntegration;
